import { api } from 'api/api';
import { Endpoints } from 'api/constants';
import { TableDataResponse } from 'types/general';
import { IClaim } from 'types/income';
import { exportXlsxConfig } from 'utils/general';
import { ClaimStatus, ClaimsFilters } from './claims.types';

const getFilters = (filters: Partial<ClaimsFilters>) => ({
  page: filters.page,
  pageSize: filters.pageSize,
  search: filters.search || undefined,
  filter: {
    companyId: filters.company,
    benefitId: filters.benefit,
    status: filters.status,
    mismatch: filters.mismatch,
    claimDateFrom: filters.claimDate?.from,
    claimDateTo: filters.claimDate?.to,
    purchaseDateFrom: filters.purchaseDate?.from,
    purchaseDateTo: filters.purchaseDate?.to,
    expenseDateFrom: filters.expenseDate?.from,
    expenseDateTo: filters.expenseDate?.to,
  },
});

interface GetClaims {
  filters: Partial<ClaimsFilters>;
}

interface GetClaim {
  claimId: string;
}

interface UpdateClaim {
  claimId: string;
  data: Partial<{
    status: ClaimStatus;
    adminComment: string;
    purchaseDate: string;
    approvedAmount: number;
    supplier: string;
  }>;
}

interface UpdateClaims {
  updates: Array<{ claimId: string; status: ClaimStatus }>;
}

interface ExportXls {
  filters: Partial<ClaimsFilters>;
}

export const loaders = {
  getClaims: ({ filters }: GetClaims) => {
    return api<TableDataResponse<IClaim>>({
      url: Endpoints.clientAdmin.claims.root,
      params: getFilters(filters),
    });
  },
  getClaim: ({ claimId }: GetClaim) => {
    return api<IClaim>({
      url: Endpoints.clientAdmin.claims.byId.replace(':claimId', claimId),
    });
  },
  updateClaim: ({ claimId, data: { supplier, ...data } }: UpdateClaim) => {
    return api({
      url: Endpoints.clientAdmin.claims.byId.replace(':claimId', claimId),
      method: 'patch',
      data: {
        ...data,
        employeeComment: supplier,
      },
    });
  },
  updateClaims: ({ updates }: UpdateClaims) => {
    return api({
      url: Endpoints.clientAdmin.claims.bulk,
      method: 'patch',
      data: {
        requests: updates,
      },
    });
  },
  exportXls: ({ filters }: ExportXls) => {
    const { pageSize, page, ...params } = getFilters(filters);

    return api({
      url: Endpoints.clientAdmin.claims.export.xls,
      params,
      ...exportXlsxConfig,
    });
  },
};
